export const siteInfo = {
  name: '17c吃瓜',
  tagline: '今日热门事件实时更新',
  slogan: '一手瓜源持续刷新，把碎片传闻串成完整脉络',
  description:
    '17c吃瓜聚焦全网热议话题，实时更新今日热门事件，深挖最新爆料内幕，梳理事件脉络、关键细节与网友焦点，让你三分钟看懂一件事。',
  email: 'hello@17cchigua.example',
  bKeyword: '今日热门事件 · 最新爆料 · 全网热议',
  updatedAt: '2026-09-12 09:30',
  updateFrequency: '平均 12 分钟刷新一次热榜',
};

export const navLinks = [
  { label: '今日热榜', href: '#hot', anchor: 'hot' },
  { label: '热门事件', href: '#events', anchor: 'events' },
  { label: '主题分类', href: '#topics', anchor: 'topics' },
  { label: '深度爆料', href: '#digest', anchor: 'digest' },
  { label: '常见问题', href: '#faq', anchor: 'faq' },
];

export const hotTopics = [
  { rank: 1, title: '选秀综艺收官夜三大争议：票数、剪辑与临时改编', slug: 'variety-finale-three-disputes', heat: 98, tag: '爆' },
  { rank: 2, title: '短剧演员涨粉百万后解约风波，分成比例成核心分歧', slug: 'short-drama-creator-contract', heat: 92, tag: '热' },
  { rank: 3, title: '都市剧大结局口碑两极，原著党与路人观众吵成两派', slug: 'drama-ending-split-reviews', heat: 88, tag: '热' },
  { rank: 4, title: '直播带货"全网最低价"承诺引热议，平台规则再收紧', slug: 'live-commerce-price-promise', heat: 84, tag: '新' },
  { rank: 5, title: '演唱会退票新规落地，观众与主办方的博弈', slug: 'concert-ticket-rule-change', heat: 79, tag: '新' },
  { rank: 6, title: '职场"隐形加班"话题登上热榜，评论区成大型共鸣现场', slug: 'hidden-overtime-topic', heat: 76, tag: '议' },
  { rank: 7, title: '旅行博主作品被指撞图，原创边界再成讨论焦点', slug: 'travel-blogger-image-dispute', heat: 72, tag: '议' },
  { rank: 8, title: '情感综艺素人嘉宾走红，节目组回应剪辑争议', slug: 'variety-editing-response', heat: 69, tag: '议' },
  { rank: 9, title: '联名营销翻车始末：从设计图到致歉声明的全过程', slug: 'co-branding-misstep', heat: 66, tag: '析' },
  { rank: 10, title: '剧集片头被指抄袭风波，制作方公布创作时间线', slug: 'opening-credit-dispute', heat: 63, tag: '析' },
];

export const stats = [
  { value: '480+', label: '本月已梳理事件' },
  { value: '12 分钟', label: '热榜平均刷新间隔' },
  { value: '6 大', label: '内容主题栏目' },
  { value: '98.2%', label: '读者停留完成率' },
];

export const testimonials = [
  {
    name: '林小满',
    role: '在校学生',
    content:
      '以前刷到一半就被各种截图搞懵，现在习惯先来这边看时间线，五分钟就能搞清楚到底发生了什么，再回去看评论区也不会被带偏。',
  },
  {
    name: '周予安',
    role: '新媒体编辑',
    content:
      '栏目分类做得挺细，找素材回看事件过程很方便。最难得的是它只写公开信息和双方说法，不会替读者下结论。',
  },
  {
    name: '陈默',
    role: '产品经理',
    content:
      '通勤路上看热榜，晚上回来再看深度爆料，节奏很舒服。排版不吵，广告也不多，读起来没有负担。',
  },
  {
    name: '贝贝酱',
    role: '自由插画师',
    content:
      '喜欢它把"关键要点"单独拎出来的做法，急着了解的时候扫一眼就够了，想细看再往下读，对碎片时间很友好。',
  },
];

export const faqs = [
  {
    q: '17c吃瓜的内容主要来自哪里？',
    a: '站内事件均由编辑整理自各方公开发布的信息，包括当事人声明、官方公告与主流媒体报道。我们会在正文中标注信息的时间与来源方向，不采用无法核实的匿名私信内容。',
  },
  {
    q: '热榜的排序依据是什么？',
    a: '热榜综合了全网讨论量、话题增速与持续时间三个维度，每十二分钟刷新一次。热度值只反映讨论规模，不代表我们对该事件的立场或判断。',
  },
  {
    q: '为什么同一个事件会有多条更新？',
    a: '大多数热点都会持续发展。我们在原事件页内以时间线的方式追加更新，而不是另开一篇新文章，这样你回看时能看到从最初爆料到官方回应的完整过程。',
  },
  {
    q: '可以投稿或提供线索吗？',
    a: '可以。欢迎通过订阅表单留下你的联系方式与线索方向，编辑会进行核实。请注意，我们只处理能够提供公开可查依据的线索。',
  },
  {
    q: '站内观点是否代表某种立场？',
    a: '不代表。我们尽量把双方说法并列呈现，并明确区分"已确认信息"与"网传内容"。如果你发现某篇文章的表述有失偏颇，欢迎随时指出。',
  },
  {
    q: '内容会持续保留吗？',
    a: '会。事件详情页在更新后不会删除历史节点，方便你回溯整个过程。只有涉及明显不实或侵犯权益的内容，我们才会依法依规进行处理。',
  },
];